import React, { useState, useEffect, useContext } from 'react';
import { H4 } from '../../components/Typography/styles';
import {
  DashboardContainer,
  DashboardContent,
  DashboardHeader,
  DashboardHaderTitle,
  DashboardHaderGrid,
  FadeContainer,
  DashboardEmptyStateContainer,
  DashboardEmptyStateParagraph
} from './styles';
import { SessionContext } from '../../store';
import { getCreditsBy, getCreditsToCancel, getCreditsWithPendingDocuments, getCreditsWithPendingIdentityValidation, getCreditsWithPendingIdentityValidationDirector } from '../../services/solicitations';
import { sortByDate } from '../../helpers/sort';
import { distinctByDescription } from '../../helpers/distinct';
import Filter from '../../components/Filter';
import DashboardListByRow from '../../components/DashboardListByRow';
import DashboardListByCol from '../../components/DashboardListByCol';
import ScrollBackToTop from '../../components/ScrollBackToTop';
import Copyright from '../../components/Copyright';
import colors from '../../assets/styles/colors';
import Loader from '../../components/Loader';
import emptyState from '../../assets/images/empty.svg';
import { useHistory } from 'react-router';
import SearchField from '../../components/SearchField';
import ModalAction from '../../components/ModalAction';
import { getCausalesAnulacion, saveCreditAnulacion } from '../../services/credit';
import { BsExclamation } from 'react-icons/bs';
import NewDashboardListByRow from '../../components/NewDashboardListByRow';

const DashboardPage = ({ canalEstado, titulo, descripcion }) => {
  const session = useContext(SessionContext);
  const [completeListSolicitations, setCompleteListSolicitations] = useState([]);
  const [solicitations, setSolicitations] = useState([]);
  const [statusDescription, setStatusDescription] = useState([]);
  const [search, setSearch] = useState('');
  const [showScroll, setShowScroll] = useState(false)
  const [orderByCurrent, setOrderByCurrent] = useState(true);
  const [showByExpand, setShowByExpand] = useState(false);
  const [gridByRow, setGridByRow] = useState(false);
  const [showBy, setShowBy] = useState('Todos');
  const [fadeToggle, setFadeToggle] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isAnulacion, setIsAnulacion] = useState(false);
  const [showModalAnular, setShowModalAnular] = useState(false);
  const [idCreditAnular, setIdCreditAnular] = useState('');
  const [showAnulacion, setShowAnulacion] = useState(false);
  const [anulacion, setAnulacion] = useState('');
  const [filteredAnulacion, setFilteredAnulacion] = useState([]);
  const [causalesAnulacion, setCausalesAnulacion] = useState([]);
  const history = useHistory();

  async function initializeStateSolicitations() {
    try {

      let solicitationsData;
      let solicitations;
      if (canalEstado === 'anular') {
        solicitations = await getCreditsToCancel(session.idAsesor);
        solicitations.data.forEach(item => {
          item.fecha = item.estadoSolicitud.fecha
          item.cliente.nombre = item.cliente.nombres
          item.estado = item.estadoSolicitud
        })
        solicitationsData = solicitations.data;
        const causalesAnulacionList = await getCausalesAnulacion();
        setCausalesAnulacion(causalesAnulacionList.data);
      } else if (canalEstado === 'adjuntar') {
        solicitations = await getCreditsWithPendingDocuments(session.idAsesor);
        solicitations.data.forEach(item => {
          item.fecha = item.estadoSolicitud.fecha
          item.cliente.nombre = item.cliente.nombres
          item.estado = item.estadoSolicitud
        })
        solicitationsData = solicitations.data;
      } else if (canalEstado === 'validacion_identidad') {
        if (session.rol !== 'rol_gestor_comercial' && session.rol !== 'rol_director_oficina') {
          solicitations = await getCreditsWithPendingIdentityValidation(session.idAsesor);
        } else {
          solicitations = await getCreditsWithPendingIdentityValidationDirector(session.idAsesor);
        }

        solicitations.data.forEach(item => {
          item.fecha = item.estadoSolicitud.fecha
          item.cliente.nombre = item.cliente.nombres
          item.estado = item.estadoSolicitud
        })
        solicitationsData = solicitations.data;
      } else {
        solicitations = await getCreditsBy(session.idAsesor, canalEstado);
        solicitations.data.forEach(item => {
          item.fecha = item.estadoSolicitud.fecha
          item.cliente.nombre = item.cliente.nombres
          item.estado = item.estadoSolicitud
        })
        solicitationsData = solicitations.data;
      }

      let newStatus = distinctByDescription(solicitationsData);

      newStatus = newStatus.map(status => {
        return {
          label: status,
          limit: 3
        }
      });

      setStatusDescription(newStatus);
      setCompleteListSolicitations(sortByDate(solicitationsData, orderByCurrent));
      if (canalEstado == 'abacus') {
        setTimeOutFade(true)
      } else {
        setTimeOutFade(false);
      }

    } catch (error) {
      setIsLoading(false)
      console.log(error)
    }
  }

  function setTimeOutFade(bool) {
    setFadeToggle(false);
    setIsLoading(false);

    setTimeout(() => {
      setGridByRow(bool);
      setFadeToggle(true);
    }, 200)
  }

  function scrollTotop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }

  function getWindowScroll() {
    if (window.scrollY > 0) {
      setShowScroll(true)
    } else {
      setShowScroll(false)
    }
  }

  function setLimitToStatus(status) {
    let solicitationsByLabelLength = solicitations.filter(solicitations => solicitations.estadoSolicitud.descripcion === status.label).length;

    let newStatus = statusDescription.map(statusDesc => {
      return status.label === statusDesc.label ? {
        label: status.label,
        limit: status.limit > 3 ? 3 : solicitationsByLabelLength
      } : statusDesc;
    });

    setStatusDescription(newStatus)
  }

  function getLengthOfFilteredSolicitationsBylabel(label) {
    return solicitations.filter(solicitation => solicitation.estadoSolicitud.descripcion === label).length;
  }

  function getLengthOfSolicitationsBylabel(label) {
    return completeListSolicitations.filter(solicitation => solicitation.estadoSolicitud.descripcion === label).length;
  }

  function getFilteredSolicitationsBylabel(label) {
    return solicitations.filter(solicitationFilter => solicitationFilter.estadoSolicitud.descripcion === label);
  }

  function setSelectedAnulacion(field) {
    setAnulacion(field.id);
    setShowAnulacion(false);
    document.getElementById("anulacion").value = field.nombre;
  }

  function searchInAnulacion(e) {
    if (e.target.value.trim() == '') {
      setAnulacion('');
    }
    setShowAnulacion(true);
    const filtered = causalesAnulacion.filter(anulacion => anulacion.nombre.toLowerCase().indexOf(e.target.value.toLocaleLowerCase()) > -1);
    setFilteredAnulacion(filtered);
  }

  async function anularCredit() {
    try {
      setIsLoading(true);

      if (!isAnulacion) {
        setIsAnulacion(true);
      } else {
        const data = {
          asesorId: session.idAsesor,
          creditoId: idCreditAnular?.id,
          causalId: anulacion
        }
        await saveCreditAnulacion(data);
        history.push('/admin/anular-list');
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    function watchScroll() {
      window.addEventListener("scroll", getWindowScroll);
    }

    watchScroll();

    return () => {
      window.removeEventListener("scroll", getWindowScroll);
    };
  });

  useEffect(() => {
    let solicitationsArr = [...completeListSolicitations];

    solicitationsArr = sortByDate(solicitationsArr, orderByCurrent);

    if (search.length) {
      solicitationsArr = solicitationsArr.filter(solicitation =>
        solicitation.cliente.identificacion.indexOf(search) > -1 ||
        solicitation.cliente.nombres.toLowerCase().indexOf(search.toLocaleLowerCase()) > -1
      );
    }

    if (showBy !== 'Todos') {
      solicitationsArr = solicitationsArr.filter(solicitation => solicitation.estadoSolicitud.descripcion === showBy);
    }

    setSolicitations(solicitationsArr);
  }, [completeListSolicitations, orderByCurrent, showBy, search]);

  useEffect(() => {
    initializeStateSolicitations();

    return () => {
      setCompleteListSolicitations([]);
      setSolicitations([]);
      setStatusDescription([]);
      setCausalesAnulacion([]);
    }
  }, []);

  return (
    <DashboardContainer id="dashboard-page">
      <DashboardContent>
        <DashboardHeader>
          <DashboardHaderTitle>{titulo}</DashboardHaderTitle>
          <DashboardHaderGrid>
            <H4 color={colors.textPrimary}>{descripcion}</H4>
          </DashboardHaderGrid>
        </DashboardHeader>
        <Filter
          orderByCurrent={orderByCurrent} setOrderByCurrent={setOrderByCurrent}
          showByExpand={showByExpand} setShowByExpand={setShowByExpand}
          showBy={showBy} setShowBy={setShowBy}
          gridByRow={gridByRow} setGridByRow={setGridByRow}
          setSearch={setSearch}
          statusDescription={statusDescription}
          setTimeOutFade={setTimeOutFade}
          canalEstado={canalEstado} />
        {!completeListSolicitations.length ? (
          <DashboardEmptyStateContainer>
            <img src={emptyState} alt="Empty state" />
            <DashboardEmptyStateParagraph>
              No hay información para visualizar
            </DashboardEmptyStateParagraph>
          </DashboardEmptyStateContainer>
        ) : ''}
        {statusDescription.map((item, statusKey) =>
          getLengthOfFilteredSolicitationsBylabel(item.label) ? (
            <FadeContainer fade={fadeToggle} key={statusKey} id="fade">
              {canalEstado === 'abacus' ? (
                gridByRow ? (
                  ''
                ) : (
                  <DashboardListByCol
                    item={item}
                    search={search}
                    showBy={showBy}
                    gridByRow={gridByRow}
                    solicitations={solicitations}
                    canalEstado={canalEstado}
                    setShowModalAnular={setShowModalAnular}
                    setIdCreditAnular={setIdCreditAnular}
                    getFilteredSolicitationsBylabel={getFilteredSolicitationsBylabel}
                    getLengthOfFilteredSolicitationsBylabel={getLengthOfFilteredSolicitationsBylabel}
                    getLengthOfSolicitationsBylabel={getLengthOfSolicitationsBylabel}
                    setLimitToStatus={setLimitToStatus}
                  />
                )
              ) : (
                gridByRow ? (
                  <DashboardListByRow
                    item={item}
                    search={search}
                    showBy={showBy}
                    solicitations={solicitations}
                    canalEstado={canalEstado}
                    setShowModalAnular={setShowModalAnular}
                    setIdCreditAnular={setIdCreditAnular}
                    getFilteredSolicitationsBylabel={getFilteredSolicitationsBylabel}
                    getLengthOfFilteredSolicitationsBylabel={getLengthOfFilteredSolicitationsBylabel}
                    getLengthOfSolicitationsBylabel={getLengthOfSolicitationsBylabel}
                    setLimitToStatus={setLimitToStatus}
                  />
                ) : (
                  <DashboardListByCol
                    item={item}
                    search={search}
                    showBy={showBy}
                    gridByRow={gridByRow}
                    solicitations={solicitations}
                    canalEstado={canalEstado}
                    setShowModalAnular={setShowModalAnular}
                    setIdCreditAnular={setIdCreditAnular}
                    getFilteredSolicitationsBylabel={getFilteredSolicitationsBylabel}
                    getLengthOfFilteredSolicitationsBylabel={getLengthOfFilteredSolicitationsBylabel}
                    getLengthOfSolicitationsBylabel={getLengthOfSolicitationsBylabel}
                    setLimitToStatus={setLimitToStatus}
                  />
                )
              )}
            </FadeContainer>
          ) : ''
        )}
        {canalEstado === 'abacus' && gridByRow &&
          <NewDashboardListByRow
            solicitations={solicitations}
            canalEstado={canalEstado}
            setShowModalAnular={setShowModalAnular}
            setIdCreditAnular={setIdCreditAnular}
          />
        }
        {isLoading && <Loader />}
        <ModalAction
          open={showModalAnular}
          setShowModal={setShowModalAnular}
          actionFunctionUpButton={anularCredit}
          actionFunctionDownButton={() => setShowModalAnular(false)}
          title={"¿Está seguro de que desea anular el crédito del cliente " + idCreditAnular.cliente?.nombre + " ?"}
          actionLabelFunctionUpButton="Confirmar"
          actionLabelFunctionDownButton="Cancelar"
          description={
            isAnulacion &&
            <SearchField
              show={showAnulacion}
              selectField={setSelectedAnulacion}
              list={filteredAnulacion}
              defaultValue={anulacion}
              id="anulacion"
              label="Seleccione la Causal de Anulación"
              searchInList={searchInAnulacion}
              placeholder="Seleccionar..." />
          }
          backgroundIcon={colors.bgTertiary}
          bodyIcon={<BsExclamation size={32} color={colors.white} />} />
      </DashboardContent>
      <Copyright />
      <ScrollBackToTop scroll={scrollTotop} show={showScroll} id="scrollback" />
    </DashboardContainer>
  )
}

export default DashboardPage;
